import React from 'react';

import { MenuItem as MenuItemComponent, MenuItemProps as SharedMenuItemProps } from '@ael/shared-components-library';

export type MenuItemProps = Omit<SharedMenuItemProps, 'messages'>;

export const MenuItem = (props: MenuItemProps) => {
  return <MenuItemComponent {...props} />;
};
